import Vue from "vue";
import Vuex from "vuex";
import mutations from "./mutations";
import * as getters from "./getters";
import * as actions from "./actions";
import storage from "./plugins/storage";
import moderator from "./plugins/moderator/";
import customers from "./modules/customers";
import security from "./modules/security";
import menus from "./modules/menus";
import cart from "./modules/cart";
import friendLists from "./modules/friendLists";
import tickets from "./modules/tickets";
import cardTransactions from "./modules/cardTransactions";
import cards from "./modules/cards";

Vue.use(Vuex);

let locale = localStorage.getItem("locale");

if (!locale) {
  locale = document.querySelector("html").lang;
}

const state = Object.assign({
  locale: locale || "ro",
  deals: [],
  layout: {
    subheader: {
      visible: true,
      logo: {
        visible: true,
      },
    },
    chat: {
      primary: { visible: false },
      secondary: { visible: false },
    },
  },
});

export default new Vuex.Store({
  modules: {
    customers,
    security,
    menus,
    cart,
    friendLists,
    tickets,
    cardTransactions,
    cards,
  },
  state,
  mutations,
  getters,
  actions,
  plugins: [storage, moderator],
});
